import React, {Component} from 'react';
import {connect} from 'react-redux';
import Action from 'components/organisms/non-controlled-hitter-stacking/actions';

class TeamChecking extends Component {
    onChange(isChecked) {
        this.props.dispatch(Action.setTeamIsCheckedForStackNumber(this.props.team, isChecked, this.props.stackNumber));
    }

    render() {
        const {stackNumber, team, stacking} = this.props;

        const isChecked = stacking.isTeamCheckedInStackNumber(team, stackNumber);

        return (
            <label className="stack-chk">
                <input
                    value="1"
                    type="checkbox"
                    onChange={(e) => ::this.onChange(e.target.checked)}
                    checked={isChecked}
                    className="form-control"
                />
                {team}
            </label>
        );
    }
}

function mapStatesToProps(state) {
    const {nonControlledHitterStacking} = state;
    return {
        stacking: nonControlledHitterStacking.settings,
    };
}

export default connect(mapStatesToProps)(TeamChecking);
